import '../css/topHeader.css';
import '../css/sidenav.css';
import logo from '../images/weokasmain.svg';
import bell from '../images/headericon/Notification1.svg';
import bell2 from '../images/headericon/Notification2.svg';
import comments from '../images/headericon/Chat.svg';
import logout from '../images/logout.svg';
import logoutGrey from '../images/logout-grey.svg';
import User from '../images/headericon/User.svg';
import Search from '../images/headericon/Search.svg';
import React, { Component } from 'react';
// import createHistory from 'history/createBrowserHistory';
import { createBrowserHistory } from 'history';
import '../css/sidenav.css';
import Support from '../images/headericon/Support.svg';
import SupportWhite from '../images/headericon/SupportWhite.svg';
import { Link } from "react-router-dom";
import DashboardWhite from '../images/sidebar/DashboardWhite.svg';
import DashboardGray from '../images/sidebar/DashboardGray.svg';
import OfficeLocationWhite from '../images/sidebar/OfficeLocationWhite.svg';
import OfficeLocationGray from '../images/sidebar/OfficeLocationGray.svg';
import ProjectManagerWhite from '../images/sidebar/ProjectManagerWhite.svg';
import ProjectManagerGray from '../images/sidebar/ProjectManagerGray.svg';
import RegisterdOkasBoxWhite from '../images/sidebar/RegisterdOkasBoxWhite.svg';
import RegisterdOkasBoxGray from '../images/sidebar/RegisterdOkasBoxGray.svg';
import si_licesnseGray from '../images/sidebar/si_licesnse.svg';
import si_licesnseWhite from '../images/sidebar/si_licesnse_white.svg';
import mlWhite from '../images/sidebar/mlWhite.svg';
import mlGray from '../images/sidebar/mlGray.svg';
import ProjectDetailWhite from '../images/sidebar/ProjectDetailWhite.svg';
import ProjectDetailGray from '../images/sidebar/ProjectDetailGray.svg';
import HelpWhite from '../images/sidebar/HelpWhite.svg';
import HelpGray from '../images/sidebar/HelpGray.svg';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import SnackBar from '../containers/SnackBar';
// import windowSize from 'react-window-size';
import Style from 'style-it';
import user from '../images/user.png'
import UserWhite from "../images/user_white.png";
import UserGray from "../images/user_fade_color.png";
import MarketpaceWhite from "../images/marketSpace_white.png";
import MarketSpaceGray from "../images/marketSpace_gray.png";
import RoleWhite from "../images/role_white.png";
import RoleGray from "../images/role_gray.png";


const sidelogoimage = {
    backgroundImage: "url(" + require('../images/okasLogo.png') + ")",
    backgroundPosition: 'left 14px bottom 26px',

    // backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
};

class TopHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listOpen: false,
            notilistOpen: false,
            opensearch: 0,

            dummyData: [
                "Element 1",
                "Element 2",
                "Element 3",
                "Element 4"
            ],
            selected: "dashboardnew",
            floorList: "collapse",
            showSome: true,
            usertype: localStorage.getItem('usertype'),
            okasVersionApidata: [],
            checkuserApidata: [],
            snackbarActive: false,
            snackbarMessage: '',
            showMenuSmallDevices: false,
            showFullScreenNavbar: false
        }
    }

    okasVersionApi = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/okasVersionApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasVersionApidata => {
                this.setState({
                    okasVersionApidata,
                    actualdata: okasVersionApidata
                }, () => {
                    this.renderokasVersionApi();
                    // console.log(this.state.okasVersionApidata)

                })
            })
    }


    renderokasVersionApi = () => {
        let xx = this.state.okasVersionApidata.map((e, index) => {
            return (
                <span key={index}>
                    {e.Application_Version}
                </span>
            )
        });
        return xx;
    }

    checkuserApi = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue
        }
        fetch('/we/we/userCheckApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(checkuserApidata => {
                // console.log(checkuserApidata)

                this.setState({
                    checkuserApidata,
                    actualdata: checkuserApidata,
                    permissions: checkuserApidata.permissions,
                    source: checkuserApidata.source
                }, () => {
                    // console.log(this.state.checkuserApidata);

                    this.props.userNameStyleActivate(this.state.checkuserApidata.user_name)
                    this.props.reuserNameStyleActivate(this.state.checkuserApidata.first_name)
                    this.props.userTypeStyleActivate(this.state.checkuserApidata.User_Type)
                    this.props.setPermssions(checkuserApidata.permissions);

                    if (this.state.checkuserApidata.status !== '200') {
                        localStorage.removeItem('auth');
                        // this.props.history.push('/login') 
                        window.location = "/login/session-timeout";
                    } else {
                        // this.getallnotification();
                        this.okasVersionApi();
                    }
                })
            })
    }


    componentWillReceiveProps(prevProps, nextProps) {
        // console.log(prevProps)
    }

    componentDidMount() {
        // let r = document.getElementById("root");
        // console.log(r)

    }


    componentWillMount() {

        this.checkuserApi();
        this.props.searchBarActivate(false)

        const history = createBrowserHistory();
        const location = history.location;
        if (localStorage.getItem('auth')) {
            if (this.props.redux.globalVar.userTypeStyle == 2) {
                if (
                    // location.pathname==='/regOkas' ||
                    location.pathname === '/projectdetail'
                    || location.pathname === '/support'
                    || location.pathname === '/chat'
                ) {

                } else {
                    // this.props.history.push('/projectdetail'); 
                }
            }
        } else {
            const history = createBrowserHistory({ forceRefresh: true });
            history.push('/login');
            this.props.history.push('/login')
        }



        if (window.innerWidth < 800) {
            this.setState({
                showSome: false,
            })
        }
        if (location.pathname === '/dashboardnew' || location.pathname === '/profile') {
            this.setState({
                selected: 'dashboardnew'
            })
        } else if (location.pathname === '/systemintegratoradd') {
            this.setState({
                selected: 'systemintegratoradd'
            })
        } else if (location.pathname === '/distributorsubscription') {
            this.setState({
                selected: 'distributorsubscription'
            })
        } else if (location.pathname === '/assignokasbox') {
            this.setState({
                selected: 'OkasInventoryPage'
            })
        }
        else if (location.pathname === '/okasassignedbox') {
            this.setState({
                selected: 'OkasInventoryPage'
            })
        } else if (location.pathname === '/okasunassignedbox') {
            this.setState({
                selected: 'OkasInventoryPage'
            })
        }
        else if (location.pathname === '/memberlicence') {
            this.setState({
                selected: 'memberlicence'
            })
        }
        // else if (location.pathname === '/officelocation') {
        //     this.setState({
        //         selected: 'officelocation'
        //     })
        else if (location.pathname === '/support2' || location.pathname === '/chat2' || location.pathname === '/remote-access2' || location.pathname === '/approve2' ||
            /^\/support2\/[^/]+$/.test(location.pathname) || // Matches /support/:id
            /^\/support2\/remote-access2\/[^/]+$/.test(location.pathname)) {

            this.setState({
                selected: 'support2'
            })
        } else if (location.pathname === '/userpage' || location.pathname === '/usertreechart') {
            this.setState({
                selected: 'userpage'
            })
        } else if (location.pathname === '/roles') {
            this.setState({
                selected: 'roles'
            })
        }
        else if (location.pathname === '/marketplace') {
            this.setState({
                selected: 'marketplace'
            })
        }
        else if (location.pathname === '/distributorshelppage' || location.pathname === '/distributorshelppage') {
            this.setState({
                selected: 'distributorshelppage'
            })
        }
    }

    setSelected = (selected) => {

        if (!selected.includes("Element")) {
            this.setState({
                floorList: "collapse"
            })
        }
        this.setState({
            selected: selected
        })
    }

    toggleFloors = () => {
        this.setState(prevState => {
            if (prevState.floorList === "collapse") {
                this.setState({
                    floorList: "collapse show"
                })
            }
            else {
                this.setState({
                    floorList: "collapse"
                })
            }
        })
    }
    openNav = () => {
        this.setState({
            showSome: !this.state.showSome
        })
    }

    redirectPage = (page) => {
        // const history = createHistory({forceRefresh: true});  
        // history.push(page); 
    }

    toggleList() {
        this.setState(prevState => ({
            listOpen: !prevState.listOpen
        }));
    }

    togglenoti = () => {
        this.setState(prevState => ({
            notilistOpen: !prevState.notilistOpen
        }));
    }



    // handleLogout = () => {
    //     fetch('/we/we/api/logoutview', {
    //         method: "GET"
    //     })
    //         .then(response => response.json())
    //         .then(data => {
    //             console.log("logout", data.message)
    //             if (data.message === "success") {
    //                 localStorage.clear()
    //                 localStorage.removeItem('auth');
    //                 localStorage.removeItem('username');
    //                 localStorage.removeItem('usertype');
    //                 localStorage.removeItem('email');
    //                 localStorage.removeItem('name');
    //                 // this.props.history.push('/login');
    //                 window.location = "/login";
    //             } else {
    //                 window.location = "/login/session-timeout";
    //             }
    //         })
    //     // this.props.history.push('/login')
    // }

    componentDidMount() {
        this.getProfileData();
        this.resetLogoutTimer(); // Start the timer when the component mounts
        window.addEventListener("mousemove", this.resetLogoutTimer);
        window.addEventListener("keydown", this.resetLogoutTimer);
    }

    componentWillUnmount() {
        clearTimeout(this.logoutTimer);
        window.removeEventListener("mousemove", this.resetLogoutTimer);
        window.removeEventListener("keydown", this.resetLogoutTimer);
    }

    resetLogoutTimer = () => {
        clearTimeout(this.logoutTimer);
        this.logoutTimer = setTimeout(() => {
            this.handleLogout();  // Call logout function after 5 seconds of inactivity
        }, 5 * 60 * 1000); // 3 seconds
    };

    handleLogout = () => {
        fetch('/we/we/api/logoutview', {
            method: "GET"
        })
            .then(response => response.json())
            .then(data => {
              //  console.log("logout", data.message);
                if (data.message === "success") {
                    localStorage.clear();
                    localStorage.removeItem('auth');
                    localStorage.removeItem('username');
                    localStorage.removeItem('usertype');
                    localStorage.removeItem('email');
                    localStorage.removeItem('name');
                    window.location = "/login";
                } else {
                    window.location = "/login/session-timeout";
                }
            })
            .catch(error => {
                console.error("Logout request failed:", error);
            });
    };



    onSearchClick = () => {
        this.props.searchBarActivate(!this.props.redux.globalVar.searchBarShow)
    }

    showMenuSmallDevices = () => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showMenuSmallDevices: !this.state.showMenuSmallDevices
        })
    }


    getProfileData = () => {
        // Set the loader to true while the request is processing
        this.setState({
            loader: true,
        });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        };

        // Example API endpoint for fetching the profile data
        fetch('/we/upload_image/', {
            method: 'GET',
            headers: headers, // Use the headers with token and CSRF token
        })
            .then(response => {
                if (!response.ok) {
                    // If the response status is not OK, throw an error
                    throw new Error('Error fetching profile data: ' + response.statusText);
                }
                return response.json(); // Parse the response as JSON
            })
            .then(data => {
                // Handle success (e.g., store data in state)
                //console.log("Profile data fetched:", data[0].image);
                this.setState({
                    profilePicture: data[0].image, // Assuming the response has this field
                    //fullName: data.fullName, // Assuming the response has this field
                    email: data.email, // Assuming the response has this field
                });
            })
            .catch(error => {
                // Handle error (e.g., show an error message)
                console.error("Error fetching profile data:", error);
            })
            .finally(() => {
                // Stop the loader after the request finishes
                this.setState({
                    loader: false,
                });
            });
    };

    render() {
        return (
            <div onContextMenu={(e) => { e.preventDefault(); }}>
                {this.state.showMenuSmallDevices ? <div className="header-menubar-active-background" onClick={() => {
                    // console.log("sd")
                    this.showMenuSmallDevices()
                }}></div> : null}
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />


                {/* //////////////////////////////////////start side bar///////////////////////////////////////////  */}
                {true ?
                    // <div
                    //     // className="sidenav pull-left hidden-xs hidden-sm hide-md-landscape"
                    //     className={this.state.showMenuSmallDevices ? "sidenav pull-left custom-width-menubar" : "sidenav pull-left hidden-xs hidden-sm hide-md-landscape"}
                    //     style={sidelogoimage} >
                    //     {/* {window.innerWidth <801 ? <span className="qwer" onClick={this.openNav.bind(this)}>&#9776;</span> : null } */}
                    //     {this.props.redux.globalVar.userTypeStyle ?
                    //      <ul>
                    //         {this.props.redux.globalVar.userTypeStyle === '3' ?

                    //             <span>
                    //                 <li><a href="/dashboardnew" className={this.state.selected === "dashboardnew" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('dashboardnew'); this.setSelected("dashboardnew") }}><div className="menuLabel ">
                    //                     {this.state.selected == 'dashboardnew' ? <img src={DashboardWhite} /> : <img src={DashboardGray} />}
                    //                     <span>Dashboard</span></div></a></li>
                    //                 <li>
                    //                     <a href="/systemintegratoradd" className={this.state.selected === "systemintegratoradd" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('systemintegratoradd'); this.setSelected("systemintegratoradd") }}><div className="menuLabel">
                    //                         {this.state.selected == 'systemintegratoradd' ? <img src={ProjectManagerWhite} /> : <img src={ProjectManagerGray} />}
                    //                         <span>Add System Integrator</span></div></a>
                    //                 </li>
                    //                 <li>
                    //                     <a href="/assignokasbox " className={this.state.selected === "OkasInventoryPage" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('OkasInventoryPage'); this.setSelected("OkasInventoryPage") }}><div className="menuLabel">
                    //                         {this.state.selected == 'OkasInventoryPage' ? <img src={RegisterdOkasBoxWhite} /> : <img src={RegisterdOkasBoxGray} />}
                    //                         <span>OKAS Inventory</span></div></a>
                    //                 </li>

                    //                 <li>
                    //                     {/* <a href="/memberlicense" className={this.state.selected === "memberlicense" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('memberlicense'); this.setSelected("memberlicense") }}> */}
                    //                     <a href='/memberlicence' className={this.state.selected === "memberlicence" ? "sidenav-button selected" : "sidenav-button"}>
                    //                         <div className="menuLabel">
                    //                             {this.state.selected == 'memberlicence' ? <img src={mlWhite} /> : <img src={mlGray} />}
                    //                             <span>Member License</span></div></a>
                    //                 </li>
                    //                 <li>
                    //                     <a href="/distributorsubscription " className={this.state.selected === "distributorsubscription" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('distributorsubscription'); this.setSelected("distributorsubscription") }}><div className="menuLabel">
                    //                         {this.state.selected == 'distributorsubscription' ? <img src={si_licesnseWhite} /> : <img src={si_licesnseGray} />}
                    //                         <span>Subscriptions</span></div></a>
                    //                 </li>
                    //                 <li><a href="/support2" className={this.state.selected === "support2" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('support2'); this.setSelected("support2") }}><div className="menuLabel">
                    //                     {this.state.selected == 'support2' ? <img src={SupportWhite} /> : <img src={Support} />}
                    //                     <span>Support</span></div></a></li>

                    //                 <li><a href="/userpage" className={this.state.selected === "userpage" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('userpage'); this.setSelected("userpage") }}><div className="menuLabel">
                    //                     {this.state.selected == 'userpage' ? <img src={SupportWhite} /> : <img src={Support} />}
                    //                     <span>Users</span></div></a></li>

                    //                 <li><a href="/roles" className={this.state.selected === "roles" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('roles'); this.setSelected("roles") }}><div className="menuLabel">
                    //                     {this.state.selected == 'roles' ? <img src={SupportWhite} /> : <img src={Support} />}
                    //                     <span>Roles</span></div></a></li>
                    //                 <li>
                    //                     {/* <a href="/help" className={this.state.selected === "help" ? "sidenav-button selected" : "sidenav-button"}
                    //                             onClick={() => { this.redirectPage('help'); this.setSelected("help") }}> */}
                    //                     <a href='/distributorshelppage' className={this.state.selected === "distributorshelppage" ? "sidenav-button selected" : "sidenav-button"}>
                    //                         <div className="menuLabel">
                    //                             {this.state.selected == 'distributorshelppage' ? <img src={HelpWhite} /> : <img src={HelpGray} />}
                    //                             <span>Help</span>
                    //                         </div>
                    //                     </a>
                    //                 </li>
                    //             </span> : null
                    //         }
                    //     </ul> : null}
                    // </div>
                    <div
                        className={
                            this.state.showMenuSmallDevices
                                ? "sidenav pull-left custom-width-menubar"
                                : "sidenav pull-left hidden-xs hidden-sm hide-md-landscape" 
                        }
                        style={sidelogoimage}
                    >
                        {this.props.redux.globalVar.userTypeStyle && (
                            <ul>
                                {this.props.redux.globalVar.userTypeStyle === '4' ? (
                                    <>
                                        {(this.state.permissions || []).map((permObj, idx) =>
                                            Object.keys(permObj).map((moduleKey) => {

                                                const { source } = this.state;

                                                let link = `/${moduleKey}`; // Default fallback

                                                if (source === "SI" && moduleKey === "support") {
                                                    link = "/support";
                                                } else if (source === "Distributor") {
                                                    if (moduleKey === "support") {
                                                        link = "/support2";
                                                    } else if (moduleKey === "role") {
                                                        link = "/roles";
                                                    } else if (moduleKey === "marketplace") {
                                                        link = "/marketplace";
                                                    } else if (moduleKey === "user") {
                                                        link = "/userpage";
                                                    } else if (moduleKey === "member licence") {
                                                        link = "/memberlicence";
                                                    } else if (moduleKey === "system integrator") {
                                                        link = "/systemintegratoradd";
                                                    } else if (moduleKey === "okas inventory") {
                                                        link = "/assignokasbox";
                                                    }
                                                }

                                                // Normalize link for comparison (remove "/" and lowercase it)
                                                // const isSelected = this.state.selected === link.replace('/', '');

                                                const currentLink = link === "/assignokasbox" ? "OkasInventoryPage" : link.replace('/', '');
                                                const isSelected = this.state.selected === currentLink;

                                                return (
                                                    <li
                                                    //  key={`${moduleKey}-${idx}`}
                                                    key={`${idx}-${moduleKey}-${Object.keys(permObj[moduleKey] || {}).join(',')}`}

                                                     >

                                                        <a
                                                            href={link}
                                                            className={isSelected ? "sidenav-button selected" : "sidenav-button"}
                                                            onClick={() => {
                                                                this.redirectPage(moduleKey);
                                                                this.setSelected(link.replace('/', '')); // store "officelocation", etc.
                                                            }}
                                                        >
                                                            <div className="menuLabel">
                                                                {(() => {


                                                                    if (link === "/support2") {
                                                                        return isSelected ? <img src={SupportWhite} /> : <img src={Support} />;
                                                                    } else if (link === "/roles") {
                                                                        return isSelected ? <img style={{ width: '15%' }} src={RoleWhite} /> : <img style={{ width: '15%' }} src={RoleGray} />;
                                                                    } else if (link === "/userpage") {
                                                                        return isSelected ? <img style={{ width: '15%' }} src={UserWhite} /> : <img style={{ width: '15%' }} src={UserGray} />;
                                                                    } else if (link === "/assignokasbox") {
                                                                        return isSelected ? <img src={RegisterdOkasBoxWhite} /> : <img src={RegisterdOkasBoxGray} />;
                                                                    } else if (link === "/systemintegratoradd") {
                                                                        return isSelected ? <img src={ProjectManagerWhite} /> : <img src={ProjectManagerGray} />;
                                                                    } else if (link === "/memberlicence") {
                                                                        return isSelected ? <img src={mlWhite} /> : <img src={mlGray} />;
                                                                    } else {
                                                                        return null; // Optional: return a fallback image or nothing 
                                                                    }
                                                                })()}
                                                                <span>
                                                                    {moduleKey.charAt(0).toUpperCase() + moduleKey.slice(1)}
                                                                </span>
                                                            </div>
                                                        </a>
                                                    </li>
                                                );
                                            })
                                        )}
                                        <li>
                                            <a
                                                href="/distributorshelppage"
                                                className={
                                                    this.state.selected === "distributorshelppage"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("distributorshelppage");
                                                    this.setSelected("distributorshelppage");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img
                                                        src={
                                                            this.state.selected === "distributorshelppage"
                                                                ? HelpWhite
                                                                : HelpGray
                                                        }
                                                        alt="Help"
                                                    />
                                                    <span>Help</span>
                                                </div>
                                            </a>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                        <li>
                                            <a
                                                href="/dashboardnew"
                                                className={
                                                    this.state.selected === "dashboardnew"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("dashboardnew");
                                                    this.setSelected("dashboardnew");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img
                                                        src={
                                                            this.state.selected === "dashboardnew"
                                                                ? DashboardWhite
                                                                : DashboardGray
                                                        }
                                                        alt="Dashboard"
                                                    />
                                                    <span>Dashboard</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/systemintegratoradd"
                                                className={
                                                    this.state.selected === "systemintegratoradd"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("systemintegratoradd");
                                                    this.setSelected("systemintegratoradd");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img
                                                        src={
                                                            this.state.selected === "systemintegratoradd"
                                                                ? ProjectManagerWhite
                                                                : ProjectManagerGray
                                                        }
                                                        alt="Add System Integrator"
                                                    />
                                                    <span>Add System Integrator</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/assignokasbox"
                                                className={
                                                    this.state.selected === "OkasInventoryPage"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("OkasInventoryPage");
                                                    this.setSelected("OkasInventoryPage");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img
                                                        src={
                                                            this.state.selected === "OkasInventoryPage"
                                                                ? RegisterdOkasBoxWhite
                                                                : RegisterdOkasBoxGray
                                                        }
                                                        alt="OKAS Inventory"
                                                    />
                                                    <span>OKAS Inventory</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/memberlicence"
                                                className={
                                                    this.state.selected === "memberlicence"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("memberlicence");
                                                    this.setSelected("memberlicence");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img
                                                        src={
                                                            this.state.selected === "memberlicence"
                                                                ? mlWhite
                                                                : mlGray
                                                        }
                                                        alt="Member License"
                                                    />
                                                    <span>Member License</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/distributorsubscription"
                                                className={
                                                    this.state.selected === "distributorsubscription"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("distributorsubscription");
                                                    this.setSelected("distributorsubscription");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img
                                                        src={
                                                            this.state.selected === "distributorsubscription"
                                                                ? si_licesnseWhite
                                                                : si_licesnseGray
                                                        }
                                                        alt="Subscriptions"
                                                    />
                                                    <span>Subscriptions</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/support2"
                                                className={
                                                    this.state.selected === "support2"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("support2");
                                                    this.setSelected("support2");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img
                                                        src={
                                                            this.state.selected === "support2"
                                                                ? SupportWhite
                                                                : Support
                                                        }
                                                        alt="Support"
                                                    />
                                                    <span>Support</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/userpage"
                                                className={
                                                    this.state.selected === "userpage"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("userpage");
                                                    this.setSelected("userpage");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img style={{ width: '15%' }}
                                                        src={
                                                            this.state.selected === "userpage"
                                                                ? UserWhite
                                                                : UserGray
                                                        }
                                                        alt="Users"
                                                    />
                                                    <span>Users</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/roles"
                                                className={
                                                    this.state.selected === "roles"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("roles");
                                                    this.setSelected("roles");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img style={{ width: '15%' }}
                                                        src={
                                                            this.state.selected === "roles"
                                                                ? RoleWhite
                                                                : RoleGray
                                                        }
                                                        alt="Roles"
                                                    />
                                                    <span>Roles</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/marketplace"
                                                className={
                                                    this.state.selected === "marketplace"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("marketplace");
                                                    this.setSelected("marketplace");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img style={{ width: '15%' }}
                                                        src={
                                                            this.state.selected === "marketplace"
                                                                ? MarketpaceWhite
                                                                : MarketSpaceGray
                                                        }
                                                        alt="Roles"
                                                    />
                                                    <span>Market Place</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/distributorshelppage"
                                                className={
                                                    this.state.selected === "distributorshelppage"
                                                        ? "sidenav-button selected"
                                                        : "sidenav-button"
                                                }
                                                onClick={() => {
                                                    this.redirectPage("distributorshelppage");
                                                    this.setSelected("distributorshelppage");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    <img
                                                        src={
                                                            this.state.selected === "distributorshelppage"
                                                                ? HelpWhite
                                                                : HelpGray
                                                        }
                                                        alt="Help"
                                                    />
                                                    <span>Help</span>
                                                </div>
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        )}
                    </div>

                    :
                    <div className="sidenav1">
                    </div>
                }
                {/* /////////////////////////////////////////////////////////sidebar////////////////////////////// */}
                <div className="floatingTopHeader">
                    {true ? <div className="hidden-lg hidden-xs menu-hide-ipad-custom" style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        padding: "0 0px",
                        color: "#bcbccb",
                        margin: "auto 0 auto 10px",
                        paddingRight: "10px",
                        borderRight: "1px solid #BCBCCB",

                    }}
                        //  onClick={this.openNav.bind(this)}
                        onClick={() => {
                            this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop)
                            this.showMenuSmallDevices()
                        }}
                    >
                        &#9776; Menu</div> : null}
                    <div className="leftSection">
                        {/* <a href={this.props.redux.globalVar.userTypeStyle == 2 ? "/projectdetail" : "/dashboard"}><img src={logo} /></a> */}
                        <a
                            href={this.props.redux.globalVar.userTypeStyle === 2 ? "/projectdetail" : "/dashboard"}
                            onClick={(e) => {
                                if (this.props.redux.globalVar.userTypeStyle === '4') {
                                    e.preventDefault(); // 🔒 Block navigation
                                }
                            }}
                            style={{
                                pointerEvents: this.props.redux.globalVar.userTypeStyle === 4 ? 'none' : 'auto',
                                opacity: this.props.redux.globalVar.userTypeStyle === 4 ? 0.5 : 1,
                                cursor: this.props.redux.globalVar.userTypeStyle === 4 ? 'default' : 'pointer'
                            }}
                        >
                            <img src={logo} alt="Logo" />
                        </a>

                        {/* <div className="version">
                                V 0.1
                            </div> */}
                    </div>
                    <div className="rightSection" style={{ marginLeft: 'auto', position: 'relative', }}>
                        <div className="icons">
                            {createBrowserHistory().location.pathname === '/dashboard' || createBrowserHistory().location.pathname === '/help' || createBrowserHistory().location.pathname === '/design-help' || createBrowserHistory().location.pathname === '/chat' ?
                                null
                                :
                                <a onClick={this.onSearchClick.bind(this)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} aria-label="Search">
                                    <img src={Search} className="hidden-xs hidden-sm" alt="Search" style={{ width: '20px', height: '20px' }} />
                                </a>
                            }
                        </div>
                    </div>
                    <div className="rightSection">
                        {this.props.redux.globalVar.userTypeStyle === '3' ?
                            <React.Fragment>
                                <div id="myNav" class="overlay hidden-lg hidden-md hidden-sm"
                                    style={{
                                        display: this.state.showFullScreenNavbar ? "block" : "none"
                                    }}

                                >
                                    <a href="javascript:void(0)" class="closebtn"
                                        onClick={() => {

                                            this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop)
                                            this.setState({
                                                showFullScreenNavbar: !this.state.showFullScreenNavbar
                                            })
                                        }}>&times;</a>
                                    <div class="overlay-content">
                                        <a href="#">
                                            <a href="/dashboardnew" className={this.state.selected === "dashboardnew" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('dashboardnew'); this.setSelected("dashboardnew") }}><div className="menuLabel ">
                                                {this.state.selected == 'dashboardnew' ? <img src={DashboardWhite} /> : <img src={DashboardGray} />}
                                                <span>Dashboard</span></div></a>
                                        </a>
                                        <a href="/systemintegratoradd" className={this.state.selected === "systemintegratoradd" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('systemintegratoradd'); this.setSelected("systemintegratoradd") }}><div className="menuLabel">
                                            {this.state.selected == 'systemintegratoradd' ? <img src={ProjectManagerWhite} /> : <img src={ProjectManagerGray} />}
                                            <span>Add System Integrator</span></div>
                                        </a>
                                        <a href="#"><a href="/assignokasbox" className={this.state.selected === "OkasInventoryPage" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('OkasInventoryPage'); this.setSelected("OkasInventoryPage") }}><div className="menuLabel">
                                            {this.state.selected == 'OkasInventoryPage' ? <img src={RegisterdOkasBoxWhite} /> : <img src={RegisterdOkasBoxGray} />}
                                            <span>OKAS Inventory</span></div>
                                        </a></a>
                                        {/* <a href="#"> */}
                                        {/* <a href="/memberlicense" className={this.state.selected === "memberlicense" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('memberlicense'); this.setSelected("memberlicense") }}> */}
                                        <a href="/memberlicence" className={this.state.selected === "memberlicence" ? "sidenav-button selected" : "sidenav-button"}>
                                            <div className="menuLabel">
                                                {this.state.selected == 'memberlicence' ? <img src={RegisterdOkasBoxWhite} /> : <img src={RegisterdOkasBoxGray} />}
                                                <span>Member License</span></div></a>
                                        {/* </a>                               */}

                                        <a href="/distributorsubscription" className={this.state.selected === "distributorsubscription" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('distributorsubscription'); this.setSelected("distributorsubscription") }}><div className="menuLabel">
                                            {this.state.selected == 'distributorsubscription' ? <img src={si_licesnseWhite} /> : <img src={si_licesnseGray} />}
                                            <span>Subscriptions</span></div>
                                        </a>

                                        <a href="/support2" className={this.state.selected === "support2" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('support2'); this.setSelected("support2") }}><div className="menuLabel">
                                            {this.state.selected == 'support2' ? <img src={SupportWhite} /> : <img src={Support} />}
                                            <span>Support</span></div></a>


                                        {/* <a href="#"> */}
                                        {/* <a href="/help" className={this.state.selected === "help" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('help'); this.setSelected("help") }}> */}
                                        <a href="/distributorshelppage" className={this.state.selected === "distributorshelppage" ? "sidenav-button selected" : "sidenav-button"}>
                                            <div className="menuLabel">
                                                {this.state.selected == 'distributorshelppage' ? <img src={HelpWhite} /> : <img src={HelpGray} />}
                                                <span>Help</span>
                                            </div>
                                        </a>
                                        {/* </a> */}
                                        <a href="#" onClick={this.handleLogout} className="sidenav-button">
                                            <a className="sidenav-button" to="">
                                                <div className="menuLabel">
                                                    <img src={logoutGrey} />
                                                    <span>Logout</span>
                                                </div>
                                            </a>
                                        </a>
                                    </div>
                                </div> </React.Fragment> : null}
                        <div className="userDetails hidden-xs">
                            <div className="userIcon" onClick={() => this.toggleList()}>
                                <div className="userName  usernamedatas">
                                    {window.innerWidth < 801 ? null : this.props.redux.globalVar.reUserNameStyle}
                                    {/* <img src={this.state.profilePicture}  style={{
                                        height: '35px',
                                        width: '35px',
                                        borderRadius: '50%',
                                        objectFit: 'cover'
                                    }} className="usermarginleft" /> */}
                                    <img
                                        src={
                                            localStorage.getItem("name") === "2" || !this.state.profilePicture
                                                ? User
                                                : this.state.profilePicture
                                        }
                                        style={{
                                            height: '35px',
                                            width: '35px',
                                            borderRadius: '50%',
                                            objectFit: 'contain'
                                        }}
                                        className="usermarginleft"
                                        alt="User Profile"
                                    />

                                </div>
                                {this.state.listOpen && <span>
                                    <ul className="userMenu" style={{
                                        listStyle: "none",
                                        padding: "10px",
                                        margin: "0",
                                        background: "#f8f9fa",
                                        borderRadius: "8px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        width: "150px"
                                    }}>
                                        <li
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #ddd",
                                                transition: "background 0.3s",
                                                fontSize: "14px"
                                            }}
                                            onMouseEnter={(e) => e.target.style.background = "#e9ecef"}
                                            onMouseLeave={(e) => e.target.style.background = "transparent"}
                                        >
                                            <a
                                                href="/profile"
                                                style={{
                                                    textDecoration: "none",
                                                    color: "inherit",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "100%"
                                                }}
                                            >
                                                <img src={user} alt="Profile" style={{ width: "18px", marginRight: "8px" }} />
                                                Profile
                                            </a>
                                        </li>

                                        <li
                                            onClick={this.handleLogout}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                transition: "background 0.3s",
                                                fontSize: "14px"
                                            }}
                                            onMouseEnter={(e) => e.target.style.background = "#e9ecef"}
                                            onMouseLeave={(e) => e.target.style.background = "transparent"}
                                        >
                                            <img src={logout} alt="Logout" style={{ width: "18px", marginRight: "8px" }} />
                                            Logout
                                        </li>
                                    </ul>

                                </span>}
                            </div>
                        </div>
                        <div className="usermarginleft visible-xs" onClick={() => {
                            this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop)
                            this.setState({
                                showFullScreenNavbar: !this.state.showFullScreenNavbar
                            })
                        }}> &#9776;</div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        userNameStyleActivate: (data) => dispatch({ type: ActionTypes.USERNAMESTYLE, data: data }),
        reuserNameStyleActivate: (data) => dispatch({ type: ActionTypes.REUSERNAMESTYLE, data: data }),
        userTypeStyleActivate: (data) => dispatch({ type: ActionTypes.USERTYPESTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),
        setPermssions: (data) => dispatch({ type: ActionTypes.PERMISSIONS, data: data })
    };
};


// export default windowSize(connect(mapStateToProps, mapDispatchToProps)(TopHeader));

export default connect(mapStateToProps, mapDispatchToProps)(TopHeader);
